var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"h3",domProps:{"textContent":_vm._s(_vm.translate('lblGrowingRegionHeadline'))}}),_c('div',{staticClass:"form-row row"},[_c('div',{staticClass:"col-4 col-m-2 mb-s-3 mb-m-0"},[_vm._t("postal")],2),_c('div',{staticClass:"col-8 col-m-4"},[_vm._t("place")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }